module.exports = __webpack_public_path__ + "static/media/filter.b51a14a4.svg";